<template>
  <div class="pb-16">
    <div style="display: flex; align-items: center; justify-content: space-between">
      <p style="margin: 0" class="entry-date-title">
        {{ adminText('workflowsAll.entry_with_this_ticket_is_restricted_by_date__e262725', 'Entry with this ticket is restricted by date range') }}
      </p>
      <v-switch
        v-model="form.hasDateValidationRange"
        style="flex: 0 1 0%"
        :validator="validator.hasDateValidationRange"
      />
    </div>
    <p class="entry-date-description">
      {{ adminText('workflowsAll.this_enables_you_to_limit_when_tickets_can_be_eabc89b', 'This enables you to limit when tickets can be scanned for entry to the event using the CoreEvent Scanner app. For example, for a festival with tickets for Friday and Saturday, enabling this ensures that Friday tickets can only be scanned on Friday, and Saturday tickets only on Saturday. The valid dates for each ticket will be printed on the ticket.') }}
    </p>
    <div v-if="form.hasDateValidationRange">
      <div style="display: flex; align-items: center">
        <v-checkbox v-model="isSingleDay" :label="adminText('workflowsAll.single_day_0af1a3d', 'Single Day')" />
        <v-checkbox v-model="isMultipleDays" :label="adminText('workflowsAll.multiple_days_2f4458c', 'Multiple Days')" />
      </div>
      <div style="display: flex; align-items: center; justify-content: space-between; gap: 24px">
        <datetime-field
          v-model="form.entryFrom"
          style="width: 50%"
          :label="adminText('workflowsAll.start_date_976276c', 'Start Date*')"
          :validator="validator.entryFrom"
          :max="form.entryTo ? form.entryTo.toString() : event.to.toString()"
          :min="new Date().toString()"
        />
        <datetime-field
          v-model="form.entryTo"
          :disabled="!form.entryFrom"
          style="width: 50%"
          :label="adminText('workflowsAll.end_date_ab621d2', 'End Date*')"
          :validator="validator.entryTo"
          :min="form.entryFrom ? form.entryFrom.toString() : null"
          :max="event.to.toString()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { ValidityType } from '@/types'

export default {
  mixins: [WorkflowDisplay],
  name: 'entry-date-range-fields',
  props: {
    form: {
      type: Object,
      required: true,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isSingleDay: {
      get() {
        return this.form.validityType === ValidityType.SINGLE_DAY
      },
      set(value) {
        this.form.validityType = value ? ValidityType.SINGLE_DAY : ValidityType.MULTIPLE_DAYS
      },
    },
    isMultipleDays: {
      get() {
        return this.form.validityType === ValidityType.MULTIPLE_DAYS
      },
      set(value) {
        this.form.validityType = value ? ValidityType.MULTIPLE_DAYS : ValidityType.SINGLE_DAY
      },
    },
  },
  watch: {
    'form.hasDateValidationRange'(val) {
      if (val && !this.form.validityType) {
        this.$set(this.form, 'validityType', ValidityType.SINGLE_DAY)
      }
    },
  },
  mounted() {
    if (this.form.hasDateValidationRange && !this.form.validityType) {
      this.$set(this.form, 'validityType', ValidityType.SINGLE_DAY)
    }
  },
}
</script>

<style scoped>
.entry-date-title {
  color: var(--Grey-10, #666);

  /* Input/Large */
  font-family: 'Source Sans Pro';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 21.6px */
}

.entry-date-description {
  color: var(--Grey-10, #666);

  /* M3/body/small */
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.4px;
}
</style>
